import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { AddCircle } from '@material-ui/icons';
import customTheme from 'commonComponents/orangeTheme';

const orangeAddCircle = ({ ...props }) => (
  <MuiThemeProvider
    theme={
      createMuiTheme({
        ...customTheme
      })
    }
  >
    <AddCircle
      { ...props }
    />
  </MuiThemeProvider>
);

export default orangeAddCircle;
